import { showFailed } from "../../Customs/SweetAlerts";
import axiosInstance from "../../Middleware/AxiosInstanceInterceptor";

// Add Role
export const addCMSRole = async (formData, permissions) => {
    const updatedData = {
        name: formData.name,
        email: formData.email,
        phone_number: formData.phone_number,
        gender: formData.gender,
        role: formData.role.toLowerCase(),
        permissions: permissions
    }
    try {
        const response = await axiosInstance.post(`/cms-roles`, updatedData);
        const data = response.data;

        if (response.status === 200) {
            return data;
        }
        else {
            showFailed('Failed.', `${response.status}`);
        }
    }
    catch (error) {
        showFailed('Failed.', `${error.response.statusText}`);
    }
}

// Update Role
export const updateCMSRole = async (formData, userId, permissions) => {
    const updatedData = {
        name: formData.name,
        email: formData.email,
        phone_number: formData.phone_number,
        gender: formData.gender,
        role: formData.role.toLowerCase(),
        permissions: permissions
    }
    try {
        const response = await axiosInstance.patch(`/cms-roles/${userId}`, updatedData);
        const data = response.data;

        if (response.status === 200) {
            return data;
        } else {
            showFailed('Failed.', `${response.status}`);
        }
    } catch (error) {
        showFailed('Failed.', `${error.response.data.error[0]}`);
    }
};

// Delete Role
export const deleteCMSRole = async (userId) => {
    try {
        const response = await axiosInstance.delete(`/cms-roles/${userId}`);
        const data = response.data;

        if (response.status === 200) {
            return data;
        } else {
            showFailed('Failed.', `${response.status}`);
        }
    } catch (error) {
        showFailed('Failed.', `${error.response.data.error[0]}`);
    }
};